import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvRecordTableProps {
  label: string;
  children: ReactNode;
}

const OvRecordTable: FC<OvRecordTableProps> = ({ label, children }) => (
  <ScrollRegion role="region" aria-label={label} tabIndex={0}>
    <Table>{children}</Table>
  </ScrollRegion>
);

export default OvRecordTable;

const ScrollRegion = styled.div`
  overflow-x: auto;

  &:focus-visible {
    outline: 3px solid ${Colours.OV_ACCENT_BLUE};
    outline-offset: 2px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: ${Variables.fontSizes.MEDIUM};
  line-height: 1.45;

  th {
    padding: 0.75rem 0.4375rem;
    border-bottom: 1px solid ${Colours.OV_BORDER_COLOR_V3};
    color: ${Colours.OV_CHARCOAL};
    font-size: ${Variables.fontSizes.SMALL};
    font-weight: normal;
    text-align: left;
    vertical-align: middle;
    white-space: nowrap;
  }

  td {
    padding: 0.875rem 0.4375rem;
    border-bottom: 1px solid rgb(235, 237, 240);
    vertical-align: top;
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }
`;
